import React, { Component } from 'react'
import Draggable from 'react-draggable'
import { Resizable, ResizableBox } from 'react-resizable'

class PopupWindow extends Component {

    static propTypes = {
        header: React.PropTypes.string.isRequired,
        onClose: React.PropTypes.func,
        top: React.PropTypes.number,
        left: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        show_cut_down: React.PropTypes.bool,
        show_close: React.PropTypes.bool,
        show_header:React.PropTypes.bool,
        draggable:React.PropTypes.bool,
        resizable:React.PropTypes.bool,
        onDragStop: React.PropTypes.func,
        onResize: React.PropTypes.func,
        onResizeStop: React.PropTypes.func,
        onToggleCutDown: React.PropTypes.func,
        is_cut_down: React.PropTypes.bool,
        hidden: React.PropTypes.bool,
        zIndex: React.PropTypes.number,
    }

    static defaultProps = {
      top: 10, left: 500,
      width: 400,
      show_cut_down: true,
      show_close: true,
      show_header: true,
      draggable: true,
      resizable: false,
      is_cut_down: false,
      hidden: false,
      zIndex: 6
    }

    constructor(props) {
        super(props);

        this.is_cut_down = props.is_cut_down;
        this.toggle_cut_down = this.toggle_cut_down.bind(this);
        this.handleStop = this.handleStop.bind(this);

        this.width = this.props.width;

        if(this.props.height != null) {
            this.height = this.props.height;
        }
    }

    toggle_cut_down(){
        if(this.is_cut_down == true)
          this.is_cut_down = false;
        else
          this.is_cut_down = true;

        if(this.props.onToggleCutDown != null)
          this.props.onToggleCutDown(this.is_cut_down);
        else
          this.forceUpdate();
    }

    handleStop(e, data) {
      if(this.props.onDragStop != null)
          this.props.onDragStop(data.y + this.props.top, data.x + this.props.left);
    }

    render() {
        const divStyle = {
          top: this.props.top + 'px',
          left: this.props.left + 'px',
          width: this.width != null ? this.width : this.props.width + 'px',
          zIndex: this.props.zIndex
        };

        let axis = 'both';

        let bodyStyle = {

        };
        if(this.props.is_cut_down)
          bodyStyle.height = '0px;'
        else
          if(this.height != null && this.height != undefined)
            bodyStyle.height = this.height + 'px'

        var modal =   <div className="pefl-modal" style={divStyle}>
                        <div className="pefl-modal-content">
                          <div className={this.props.show_header ? "pefl-modal-header" : "hidden"}>
                            <div className="pefl-modal-header-text" style={{width: divStyle.width - 50 + 'px'}}>{this.props.header}</div>
                            <ul className="buttons_container">
                              {this.props.show_cut_down ? <li onClick={this.toggle_cut_down}  className="fa fa-angle-down"></li> : null}
                              {this.props.show_close ? <li><i className="fa fa-times close" onClick={() => this.props.onClose()}></i></li> : null}
                            </ul>
                          </div>
                          <div className="pefl-modal-body" style={bodyStyle}>
                            {this.is_cut_down != true ? this.props.children : null}
                          </div>
                        </div>
                      </div>
        
        var modal2 = this.props.resizable && this.props.is_cut_down === false ? <Resizable className="box" axis={axis} width={this.width} height={this.height} onResize={this.onResize.bind(this)} onResizeStop={this.onResizeStop.bind(this)} >{modal}</Resizable> : modal;      

        return (
            <div style={{visibility: this.props.hidden == true ? 'hidden' : 'visible'}}>
              {this.props.draggable ? <Draggable cancel=".react-resizable-handle" onStop={this.handleStop}>{modal2}</Draggable> : modal2  }
            </div>
        )
    }

    onResize (event, data) {
      let {element, size} = data;
      let {width, height} = size;
      let widthChanged = width !== this.width, heightChanged = height !== this.height;
      if (!widthChanged && !heightChanged) return;

      this.width = width;
      this.height = height;
      this.forceUpdate();

      if(this.props.onResize != null)
        this.props.onResize(width, height);
    }

    onResizeStop(event, data) {
      let {element, size} = data;
      let {width, height} = size;

      this.width = width;
      this.height = height;
      
      if(this.props.onResizeStop != null)
        this.props.onResizeStop(width, height);
    }
}

export default PopupWindow



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/PopupWindow.js
 **/